<template>
	<div :class="{ 'form-group--error': v.$error}">
		<div class="row">
				<div class="form-group col-12" :class="{'col-md-6': !isReduceWidth, 'col-md-4': isReduceWidth,}">
					<vue-tel-input @onInput="onInput" :name="name" class="form-control"
					 :class="status(v)" :only-countries="countries" :default-country="getDefaultCountryCode" 
					 :id="id" :valid-characters-only="true" :showCode="true" :placeholder="''"  :disabled="disabled">
					 </vue-tel-input>
				</div>
				<div class="form-group col-12" :class="{'col-md-6': !isReduceWidth, 'col-md-4': isReduceWidth,}">
					<div class="input-group">
						<div class="input-group-prepend">
							<span class="input-group-text">
								<span v-show="isNamePending" ><i class="fas fa-pulse fa-spinner"></i></span>
								<span v-show="!isNamePending" ><i class="fa fa-user"></i></span>
							</span>
						</div>
						<input @change="findUserByName" v-model="modelName" class="form-control"
							:class="status(v)" :disabled="disabled">
					</div>
				</div>
				
			<b-modal v-model="foundedUsersModalShow" lazy centered hide-footer hide-header>
				<div class="form-group form__item">
					<select-group v-model="country" :list="foundedCountries" :fieldValue="'C_Country_ID'"
					              :fieldText="'Name'">
						<option value="">-- {{'Country' | trans}} --</option>
					</select-group>
				</div>
				<div class="form-group form__item">
					<select-group v-model="client" :list="foundedUsersFilter" :fieldValue="'Phone'" :fieldText="'ExtendedName'">
						<option selected value="">-- {{'Client' | trans}} --</option>
					</select-group>
				</div>
				<div class="form-group form__item">
					<button class="btn btn-danger" @click.prevent="selectUser">{{'Select' | trans}}</button>
				</div>
			</b-modal>
		</div>
		<slot></slot>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import './../custom-scripts/vue-tel-input/dist/vue-tel-input.css'
	import getCountryCodes from './../custom-scripts/customCountryList'

	export default {
		props: ['id', 'name', 'pDisabled', 'v', 'value','phoneUserConnected', 'nameUserConnected', 'isReduceWidth', 'defaultIsoCode'],
		data() {
			return {
				isNamePending: false,
				isPhonePending: false,
				foundedUsersModalShow: false,
				disabled: false,
				foundedUsers: [],
				foundedCountries: [],
				client: '',
				model: '',
				modelName: '',
				phone:'',
				country: '',
				selectedCountryID: '',
				filterByName: '',
				resultat:'',
				defaultCountry: this.defaultIsoCode?this.defaultIsoCode:'GN',
				dialCode:'',
				sender:{
					name:'',
					phone:'',
					data:'',
					email:'',
					bpartner:'',
					userName:''
				},

				receiver:{
					name:'',
					phone:'',
					data:'',
					email:'',
					bpartner:''
				}
			}
		},
		mounted() {
			if(this.phoneUserConnected && this.nameUserConnected){
				if(this.name == 'sender'){
					this.model = this.phoneUserConnected
					this.$emit('input', this.model);
					this.resultat = this.nameUserConnected+" ("+this.model+")";
					this.$emit('senderResultat', this.resultat)
				}
			}
			
			this.disabled = this.pDisabled;
		},
		watch: {
			pDisabled() {
				this.disabled = this.pDisabled;
			},
			value() {
				this.model = this.$props.value;
				this.modelName = '';
				this.findUserByPhone();
			},
			country(value) {
				this.selectedCountryID = value;
			}
		},
		computed: {
			...mapGetters('Application', ['countries']),
			foundedUsersFilter() {
				if(this.selectedCountryID) {
					return this.foundedUsers.filter(item => {
						return item.bp_countr_id === this.selectedCountryID;
					});
				} else {
					return this.foundedUsers;
				}
			},
			countries() {
				const codes = getCountryCodes(this.$store.state.Application.countries);
				if (codes.length) {
					return codes
				}
			},
			getDefaultCountryCode() {
				return window.countryCode ? window.countryCode : this.defaultCountry
			}
		},
		methods: {
			onInput({number, isValid, country}) {
				this.phone = '00' + country.dialCode + number;
				if(country.dialCode == '225'){
					if(this.phone.length == 15){
						this.model = this.phone
						this.$emit('input', this.model);
					}
				}else if(isValid){
					this.model = this.phone
					this.$emit('input', this.model);
				}

			},
			selectUser() {
				let c = this.foundedUsers.find((item) => { return item.Phone == this.client; });
				if(c) {
					this.model = c.Phone;
					this.modelName = c.Name;
					this.$emit('input', this.model);
				}
				this.foundedUsersModalShow = false
			},
			async findUserByName() {
				this.$emit('reset');
				if(this.modelName) {
					this.$emit('loading');
					this.model = '';
					this.isNamePending = true;
					this.disabled = true;
					let result = await axios.get(`/user/${encodeURIComponent(this.modelName)}/byName`)
						.finally(() => {
							this.isNamePending = false;
							this.disabled = false;
							this.$emit('completed');
						});
					this.foundedUsers = result.data.response_data;
					this.foundedCountries = result.data.response_country;
					this.country = '';
					if(this.foundedUsers.length > 1) {
						this.foundedUsersModalShow = true;
					} else {
						this.model = this.foundedUsers[0].Phone;
						this.modelName = this.foundedUsers[0].Name;
						this.$emit('input', this.model);
					}
				}
			},
			async findUserByPhone() {
				this.$emit('reset');
				if(this.model) {
					this.$emit('loading');
					this.isPhonePending = true;
					this.disabled = true;
					let result = await axios.get(`/user/${encodeURIComponent(this.model)}/byPhone`)
						.finally(() => {
							this.model = ''
							this.isPhonePending = false;
							this.disabled = false;
							this.$emit('completed');
						});
						this.model = result.data.id
						this.$store.commit('Clients/setClient', result.data);
						this.model = result.data.id
						this.modelName = result.data.bpInfo.FirstName + " " + result.data.bpInfo.LastName;
						this.$emit('found', result.data);
						
						if(this.name == 'sender'){
							this.$emit('changeFlagForSrcUser', result.data.bpInfo.C_Country_ID)
							this.$emit('input', this.model);

							this.sender.name = this.modelName+" ("+this.model+")";
							this.sender.userName = this.modelName
							this.sender.phone = this.model;
							this.sender.email = result.data.userInfo.EMail
							this.sender.bpartner = result.data.profile.bpId
							this.sender.data = result.data

							this.$emit('bpSender', this.sender)
							// this.$emit('senderResultat', this.sender)
						}

						if(this.name == 'receiver'){
							this.$emit('destCountry', result.data.bpInfo.C_Country_ID)
							this.$emit('input', this.model);

							this.receiver.name = this.modelName+" ("+this.model+")";
							this.receiver.phone = this.model;
							this.receiver.email = result.data.userInfo.EMail
							this.receiver.bpartner = result.data.profile.bpId
							this.receiver.data = result.data
							this.$emit('bpReceiver', this.receiver)
						}
				}
			}
		}
	}
</script>

<style scoped>
	.form-group--error .invalid-feedback {
		display: block;
	}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/phone-user-group.vue